var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-xs-only",staticStyle:{"width":"100%"},domProps:{"innerHTML":_vm._s(_vm.getMenu())}})
}
var staticRenderFns = []

export { render, staticRenderFns }